// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animation-fadeInQuick2 {
  animation-name: fadeInQuick2;
  -webkit-animation-name: fadeInQuick2;
  animation-duration: 0.25s;
  -webkit-animation-duration: 0.25s;
  animation-timing-function: ease-out;
  -webkit-animation-timing-function: ease-out;
  visibility: visible !important;
}

.app-body .main {
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
}

.pagedisabled {
  cursor: not-allowed;
}

@keyframes ldboxrotate {
  to {
    transform: rotate(1turn);
  }
}
#app-loading {
  z-index: 10001;
  background-color: white;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.shadowed {
  box-shadow: 2px 2px 8px 0px rgb(151, 151, 151);
}

.btn-shadowed {
  box-shadow: 4px 4px 0 0 rgba(95, 95, 95, 0.29);
}

.p-0 li {
  padding: 0 !important;
}

.display-block {
  display: block !important;
}

.pull-right {
  float: right !important;
}

.fixed-width-50 {
  width: 50px !important;
}

.media-items {
  position: relative;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.7);
  transition: all 0.1s ease-out;
}

.animation-fadeInQuick2 {
  animation-name: fadeInQuick2;
  -webkit-animation-name: fadeInQuick2;
  animation-duration: 0.25s;
  -webkit-animation-duration: 0.25s;
  animation-timing-function: ease-out;
  -webkit-animation-timing-function: ease-out;
  visibility: visible !important;
}

.media-items .media-items-options {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  padding: 10px;
  display: none;
}

.media-items:hover {
  background: rgb(255, 255, 255);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
}

.media-card {
  background-color: grey;
}

.nv-file-over {
  border: dotted 3px grey;
}

.file-drop-area {
  display: block;
  min-height: 100%;
  height: auto !important;
  height: 100%;
  margin-bottom: 0px;
  padding: 0px;
}

.btn-file {
  position: relative;
  overflow: hidden;
}

.btn-file input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  background: white;
  cursor: inherit;
  display: block;
}

.link-disable {
  pointer-events: none;
  cursor: default;
}

.inline-error {
  border-bottom: 1px solid #e61515;
  border-top: 1px solid #e61515;
  color: #e61515 !important;
  text-align: center;
  line-height: 50px;
  background: white; /* For browsers that do not support gradients */
}

.inline-success {
  border-bottom: 1px solid green;
  border-top: 1px solid green;
  color: green !important;
  text-align: center;
  line-height: 50px;
  background: white; /* For browsers that do not support gradients */
}

.error-btn {
  padding-left: 10px;
  padding-right: 10px;
  margin-right: 5px;
}

.pointer {
  cursor: pointer;
}

.rc-anchor {
  transform: scale(0.77);
  -webkit-transform: scale(0.77);
  transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
}

.pointer {
  cursor: pointer;
}

.invalid {
  border: 2px dashed #e61515;
}

.card-header-docs {
  color: white !important;
}

.card-body.text-center {
  border: 2px solid #009CDE;
  border-radius: 9px;
}

.card-text {
  background: unset;
}`, "",{"version":3,"sources":["webpack://./src/app/Menus/Onboard/OnboardFiles/inlinefileuploader.component.scss"],"names":[],"mappings":"AAAA;EACI,4BAAA;EACA,oCAAA;EACA,yBAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EACA,8BAAA;AACJ;;AAEA;EAGI,OAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAGA;EACE;IACA,wBAAA;EAAA;AACF;AAGA;EACE,cAAA;EACA,uBAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EAIA,WAAA;EACA,YAAA;AAJF;;AAOA;EAII,8CAAA;AALJ;;AAQA;EAGE,8CAAA;AALF;;AAQA;EACE,qBAAA;AALF;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,uBAAA;AALF;;AAQA;EACE,sBAAA;AALF;;AAQA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;EAEA,6BAAA;AALJ;;AASA;EACI,4BAAA;EACA,oCAAA;EACA,yBAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EACA,8BAAA;AANJ;;AASA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;AANJ;;AASA;EACI,8BAAA;EAEA,wCAAA;AANJ;;AASA;EACI,sBAAA;AANJ;;AASA;EAAgB,uBAAA;AALhB;;AAOA;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAJJ;;AAMA;EACI,kBAAA;EACA,gBAAA;AAHJ;;AAKA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,UAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAFJ;;AAMA;EACI,oBAAA;EACA,eAAA;AAHJ;;AAQA;EACI,gCAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EAEA,iBAAA,EAAA,+CAAA;AANJ;;AAUA;EACI,8BAAA;EACA,2BAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EAEA,iBAAA,EAAA,+CAAA;AARJ;;AAYA;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;AATJ;;AAYA;EACI,eAAA;AATJ;;AAcA;EACI,sBAAA;EACA,8BAAA;EACA,qBAAA;EACA,6BAAA;AAXJ;;AAcA;EACI,eAAA;AAXJ;;AAaA;EACI,0BAAA;AAVJ;;AAaA;EACI,uBAAA;AAVJ;;AAYA;EACI,yBAAA;EACA,kBAAA;AATJ;;AAWA;EACI,iBAAA;AARJ","sourcesContent":[".animation-fadeInQuick2 {\n    animation-name: fadeInQuick2;\n    -webkit-animation-name: fadeInQuick2;\n    animation-duration: .25s;\n    -webkit-animation-duration: .25s;\n    animation-timing-function: ease-out;\n    -webkit-animation-timing-function: ease-out;\n    visibility: visible!important;\n}\n// Here you can add other styles\n.app-body .main {\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    overflow-x: auto;\n    overflow-y: hidden;\n}\n\n.pagedisabled {\n    cursor: not-allowed;\n}\n\n\n@keyframes ldboxrotate {\n  to {\n\t\ttransform: rotate(1turn);\n\t}\n}\n\n#app-loading {\n  z-index: 10001;\n  background-color: white;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  // display: flex;\n  // flex-direction: column;\n  // justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.shadowed {\n    \n    -webkit-box-shadow: 2px 2px 8px 0px rgb(151, 151, 151);\n    -moz-box-shadow: 2px 2px 8px 0px rgb(151, 151, 151);\n    box-shadow: 2px 2px 8px 0px rgb(151, 151, 151);\n    \n}\n.btn-shadowed {\n  -webkit-box-shadow: 4px 4px 0 0 rgba(95,95,95,.29);\n  -moz-box-shadow: 4px 4px 0 0 rgba(95,95,95,.29);\n  box-shadow: 4px 4px 0 0 rgba(95,95,95,.29);\n}\n\n.p-0 li{\n  padding : 0 !important;\n}\n\n.display-block {\n  display : block !important;\n}\n\n.pull-right{\n  float: right !important;\n}\n\n.fixed-width-50{\n  width: 50px !important;\n}\n\n.media-items {\n    position: relative;\n    border-radius: 5px;\n    text-align: center;\n    font-size: 14px;\n    cursor: pointer;\n    background: rgba(255,255,255,0.7);\n    -webkit-transition: all .1s ease-out;\n    transition: all .1s ease-out;\n}\n\n\n.animation-fadeInQuick2 {\n    animation-name: fadeInQuick2;\n    -webkit-animation-name: fadeInQuick2;\n    animation-duration: .25s;\n    -webkit-animation-duration: .25s;\n    animation-timing-function: ease-out;\n    -webkit-animation-timing-function: ease-out;\n    visibility: visible!important;\n}\n\n.media-items .media-items-options {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    padding: 10px;\n    display: none;\n}\n\n.media-items:hover {\n    background: rgba(255,255,255,1);\n    -webkit-box-shadow: 0 3px 5px rgba(0,0,0,.1);\n    box-shadow: 0 3px 5px rgba(0,0,0,.1);\n}\n\n.media-card{\n    background-color: grey;\n}\n\n.nv-file-over { border: dotted 3px grey; }\n\n.file-drop-area {\n    display: block;\n    min-height: 100%;\n    height: auto !important;\n    height: 100%;\n    margin-bottom: 0px;\n    padding: 0px;\n}\n.btn-file {\n    position: relative;\n    overflow: hidden;\n}\n.btn-file input[type=file] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    min-width: 100%;\n    min-height: 100%;\n    font-size: 100px;\n    text-align: right;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    outline: none;\n    background: white;\n    cursor: inherit;\n    display: block;\n}\n\n//Disable for <a> (links)\n.link-disable{\n    pointer-events: none;\n    cursor: default;\n}\n\n\n//Inline Statuses (for inside of pages)\n.inline-error{\n    border-bottom: 1px solid #e61515;\n    border-top: 1px solid #e61515;\n    color: #e61515 !important;\n    text-align: center;\n    line-height: 50px;\n\n    background: white; /* For browsers that do not support gradients */\n   \n}\n\n.inline-success{\n    border-bottom: 1px solid green;\n    border-top: 1px solid green;\n    color: green !important;\n    text-align: center;\n    line-height: 50px;\n\n    background: white; /* For browsers that do not support gradients */\n    \n}\n\n.error-btn {\n    padding-left: 10px;\n    padding-right: 10px;\n    margin-right: 5px;\n}\n\n.pointer{\n    cursor: pointer\n}\n\n\n\n.rc-anchor {\n    transform:scale(0.77);\n    -webkit-transform:scale(0.77);\n    transform-origin:0 0;\n    -webkit-transform-origin:0 0;\n}\n\n.pointer{\n    cursor: pointer;\n}\n.invalid{\n    border: 2px dashed #e61515;\n}\n\n.card-header-docs{\n    color: white !important;\n}\n.card-body.text-center {\n    border: 2px solid #009CDE;\n    border-radius: 9px;\n}\n.card-text{\n    background: unset;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
